/* eslint-disable indent */
import { Component } from '@verndale/core';
import Axios from 'axios';

import { breakpoints } from '../../helpers/constants';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      areasContainer: this.el.querySelector('.summer-trails-report__areas')
    };

    this.breakpoint = window.matchMedia(
      `(min-width: ${breakpoints.tabletLandscape}px)`
    );

    this.fetchData(() => {
      this.buildTable();
    });
  }

  addListeners() {
    this.breakpoint.addListener(this.buildTable.bind(this));
  }

  async fetchData(cb) {
    const { endpoint, mountain, areas } = this.el.dataset;

    try {
      const { data } = await Axios({
        method: 'GET',
        url: endpoint,
        params: {
          mountain,
          areas
        }
      });

      this.areas = data.areas;
    } catch (e) {
      console.log('Error fetching Summer trail report data');
    } finally {
      cb();
    }
  }

  buildTable() {
    const {
      openColumnHeading,
      unavailableMessage,
      unavailableLink
    } = this.el.dataset;

    const icons = {
      'Mtb - Technical Green': 'beginner',
      'Mtb - Technical Blue': 'more-difficult',
      'Mtb - Technical Black': 'most-difficult',
      'Mtb - Technical Double Black': 'expert',
      'Mtb - Freeride Green': 'freeride-green',
      'Mtb - Freeride Blue': 'freeride-blue',
      'Mtb - Freeride Black': 'freeride-black',
      'Mtb - Freeride Double Black': 'freeride-double-black',
      'Hike - Easiest': 'beginner',
      'Hike - More Difficult': 'more-difficult',
      'Hike - Most Difficult': 'most-difficult',
      'Hike - Expert Only': 'expert'
    };

    if (!this.areas && !!unavailableLink) {
      this.dom.areasContainer.innerHTML = `<li><a href="${unavailableLink}" class="summer-trails-report__error-cta">${
        unavailableMessage || 'Temporarily Unavailable'
      }</a></li>`;
    } else {
      this.dom.areasContainer.innerHTML = `<li>${
        unavailableMessage || 'Temporarily Unavailable'
      }</a></li>`;
    }

    this.dom.areasContainer.innerHTML = this.areas
      .map(
        area => `
      <li>
        <h3 class="summer-trails-report__area-title">${area.name}</h3>
        <table class="summer-trails-report__area-table">
          <thead>
            <tr>
              <th colspan="3">${openColumnHeading}</th>
              ${
                area.trails.length > 1 && this.breakpoint.matches
                  ? `
                <th colspan="3">${openColumnHeading}</th>
              `
                  : ''
              }
            </tr>
          </thead>
          <tbody>
            ${area.trails
              .map(
                (trail, index) => `
                ${!this.breakpoint.matches ? '<tr>' : ''}
                ${
                  (index % 2 === 0 && this.breakpoint.matches) ||
                  !this.breakpoint.matches
                    ? '<tr>'
                    : ''
                }
                  <td class="summer-trails-report__area-open">
                    ${
                      trail.isOpen
                        ? '<svg aria-label="Open"><title>open</title><use xlink:href="#open" /></svg>'
                        : ''
                    }
                  </td>
                  <td class="summer-trails-report__area-difficulty">
                    <svg aria-label="${trail.difficulty}"><use xlink:href="#${
                  icons[trail.difficulty]
                }" /></svg>
                  </td>
                  <td class="summer-trails-report__area-name">${trail.name}</td>
                ${
                  (index % 2 !== 0 && this.breakpoint.matches) ||
                  !this.breakpoint.matches
                    ? '<tr>'
                    : ''
                }
              `
              )
              .join('')}
          </tbody>
        </table>
      </li>
    `
      )
      .join('');
  }
}

export default Module;
